module.exports = __webpack_public_path__ + "img/relacionescolor-equipromex.85cb248d.png";